module.exports = __webpack_public_path__ + "assets/cross-2fabd5.svg";